"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * @react-component Modal - returns a react component for the modal
 */
var React = require("react");
var react_redux_1 = require("react-redux");
var flow_body_component_1 = require("./flow-body.component");
// props = { cancelUrl, header, isCloseXHidden, children }
var Modal = /** @class */ (function (_super) {
    tslib_1.__extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.modalState = _this.props.modal;
        _this.modalContainer = null;
        return _this;
    }
    Modal.prototype.render = function () {
        var _this = this;
        var renderClass = '';
        if (this.props.modal === 'open' || this.props.modal === 'animate-closed') {
            renderClass = ' vx_modalPrepToOpen vx_modalIsOpen';
        }
        return (React.createElement("div", { className: 'vx_modal-flow' + renderClass, id: 'mainModal', tabIndex: -1, ref: function (el) { return _this.modalContainer = el; }, "aria-labelledby": 'js_modalHeader' },
            React.createElement(flow_body_component_1.default, tslib_1.__assign({}, this.props))));
    };
    Modal.prototype.componentWillUpdate = function (nextProps) {
        if (nextProps.modal === this.props.modal) {
            if (this.props.modal === 'animate-open') {
                this.modalState = 'open';
            }
            else if (this.props.modal === 'animate-closed') {
                this.modalState = 'closed';
            }
        }
        else {
            this.modalState = nextProps.modal;
        }
    };
    Modal.prototype.componentDidUpdate = function () {
        if (this.modalState === 'animate-open') {
            VX.modal.open('mainModal');
            if (this.modalContainer.focus) {
                this.modalContainer.focus();
            }
        }
        else if (this.modalState === 'animate-closed') {
            VX.modal.close('mainModal');
        }
    };
    Modal.prototype.componentDidMount = function () {
        if (this.props.modal === 'animate-open') {
            VX.modal.open('mainModal');
            if (this.modalContainer.focus) {
                this.modalContainer.focus();
            }
        }
        else if (this.props.modal === 'open') {
            if (this.modalContainer.focus) {
                this.modalContainer.focus();
            }
        }
    };
    return Modal;
}(React.Component));
var ConnectedModal = react_redux_1.connect(function (state) { return state; })(Modal);
exports.default = ConnectedModal;
